import styled from 'styled-components';

import DriverInfo from './container';

export default styled(DriverInfo)`
  position: absolute;
  background: #fff;
  top: 0;
  left: 0;
  bottom: 0;
  overflow: hidden;
  overflow-y: auto;
  width: ${(props) => `${props.width}px`};
  z-index: 2;

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
  }
`;
